module.exports = __webpack_public_path__ + "static/IpadScreenshot-9ebdd315cf8892993c4ac44207c2e1d7.png";